module.exports = __webpack_public_path__ + "img/peinture-etrier-blue.19466006.jpg";